var map = {
	"./baodian.svg": "76Ux",
	"./close.svg": "peNx",
	"./del.svg": "HFQa",
	"./down.svg": "V+FA",
	"./guanjianci.svg": "R4y8",
	"./lab.svg": "qgwk",
	"./menu.svg": "jiG5",
	"./message.svg": "xz/c",
	"./more2.svg": "UVm7",
	"./pinglun.svg": "8cts",
	"./playIcon.svg": "L/z4",
	"./right.svg": "eiVh",
	"./shoucang.svg": "IPGW",
	"./smile.svg": "cHPY",
	"./top.svg": "HLVu",
	"./tuoyuan.svg": "EKEJ",
	"./video.svg": "9AUi",
	"./vip.svg": "A7YL",
	"./vip1.svg": "z4lu",
	"./wenda.svg": "AUnV",
	"./zan.svg": "Tve9",
	"./zhishi.svg": "mrKd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3Lde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg nonrecursive \.svg$
// module id = 3Lde
// module chunks = 41